import React from 'react';
import { ValidationError } from 'yup';
import { passwordValidation } from './config';

export const useRequirements = () => {
  const [errors, setErrors] = React.useState<string[]>([]);

  const verifyRequirements = (value: string): string | void => {
    try {
      passwordValidation.validateSync(value, { abortEarly: false });
      setErrors([]);
    } catch (error: unknown) {
      const err = error as { inner: ValidationError[] };
      setErrors(err.inner?.map((e: ValidationError) => e.message));
      return undefined;
    }

    return undefined;
  };

  return {
    errors,
    verifyRequirements,
  };
};
